module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/join-our-agents/career.55783e0cf759987ca0380f784af4bd6b.jpg";